import { useAppSelector as useSelector } from 'dux/app/hooks';

import { legacyTheme, styled } from '@prose-ui/legacy';
import dayjs from 'dayjs';

import { Typography } from 'Components/Typography';

import { getCartGift } from 'dux/checkoutCart/selectors';

import CheckoutBlock from './CheckoutBlock';

const Content = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const SecondContent = styled.div`
  margin-bottom: ${legacyTheme.spacing.s16};
`;

const GiftMessage = styled(Typography)`
  max-width: 400px;
`;

const CheckoutGiftSummary = () => {
  const gift = useSelector(getCartGift);

  if (!gift) {
    return null;
  }

  return (
    <CheckoutBlock dataTestId="giftee-infos" title="Gift details">
      <Content>
        <div>
          <Typography align="left" markupName="p" variant="p2">
            Recipient:
          </Typography>
          <Typography align="left" markupName="p" variant="p3">
            {gift.giftee_info.first_name} {gift.giftee_info.last_name}
          </Typography>
          <Typography align="left" markupName="p" variant="p3">
            {gift.giftee_info.email}
          </Typography>
        </div>

        <br />

        <SecondContent>
          <Typography align="left" markupName="p" variant="p2">
            Email Date:
          </Typography>
          <Typography align="left" markupName="p" variant="p3">
            {dayjs(gift.enabled_at).format('MM/DD/YYYY')}
          </Typography>
          <br />
          <Typography align="left" markupName="p" variant="p2">
            Gift Message:
          </Typography>

          <GiftMessage align="left" markupName="p" variant="p3">
            {gift.message}
          </GiftMessage>
        </SecondContent>
      </Content>
    </CheckoutBlock>
  );
};

export default CheckoutGiftSummary;
